<div class="card">
    <div class="card-header">
      <h4>Country Master Rule</h4>
    </div>
    <div class="card-body m-0">
      <div class="row mb-2">
        <div class="col-xl-12">
          <div class="text-start">
            <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()"><i class="feather icon-download me-2"></i>Export Excel</button>
            <button type="button" class="btn bg-danger-custom" (click)="quickFilterShowAction($event)"><i class="feather icon-filter me-2"></i>Quick Filters</button>
            <div class="btn-group mb-1 mb-md-0">
              <!--      <button type="button" class="btn bg-danger-custom">Columns</button>-->
              <div class="btn-group" ngbDropdown role="group">
                <button class="btn bg-danger-custom" ngbDropdownToggle><i class="feather icon-columns me-2"></i>Columns</button>
              <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                <div class="form-group">
                  <!--            <label for="columns" class="form-label"> All Columns</label>-->
                  <div *ngIf="columnDefs" class="list-group ng-option">
                    <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox" >
                      <label class="list-group-item p-2">
                        <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" value="{{i}}" name="{{column.headerName}}"
                          (change)="updateSelectedColumn($event)"
                          [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                        {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right">
                <button type="button" (click)="riskButton()" class="btn bg-danger-custom">Rating</button>
                <button type="button" (click)="labelButton()" class="btn bg-danger-custom">Add Label</button>
            </div>
          </div>
        </div>
      </div>
      
      <div *ngIf="quickFilterShow" class="row my-2" style="min-height: 100px">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-sm-3">
                <label class="col-form-label" for="fullName">Country</label>
                <input id="score" class="form-control" [(ngModel)]="country" placeholder="Enter the Country"> 
              </div>
              <div class="form-group col-sm-3">
                <label class="col-form-label" for="fullName">Rating</label>
                <ng-select #filStatus [items]="ratingNameList" bindLabel="name" bindValue="name" [(ngModel)]="ratingSelected" placeholder="Select Rating">
                </ng-select>
              </div>
              <div class="form-group col-sm-3">
                <label class="col-form-label" for="fullName">Score</label>
                <input id="score" class="form-control" [(ngModel)]="score" placeholder="Enter the Score"> 
              </div>
              <div class="col-sm-3 d-flex align-items-end">
                <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom me-2" type="button" style="width: 100%;">
                  <i class="feather icon-search me-2"></i>Search
                </button>
                <button (click)="resetFilter()" class="btn btn-secondary" type="button" style="width: 100%;">
                  <i class="feather icon-refresh-cw me-2"></i>Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (gridReady)="onGridReady($event)"
           (search)="globalSearch" [columnDefs]="tableSelectedColumn" 
            [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
            [pagination]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-4 col-xs-4 d-flex">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
          </select>
          <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
        </div>
        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
            [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
  
  <app-modal #riskConfiguration [modalConfig]="riskConfig">
<div class="text-center">
    <h5>Risk Rating range is between 0 - 10</h5>
</div>
<br>
<div>
    <div class="row d-flex">
        <div class="col-md-4">
            <input type="text" class="form-control" autocomplete="off" [(ngModel)]="lowFrom" readonly placeholder="Enter the From">
        </div>
        <div class="col-md-4">
            <input type="text" class="form-control" autocomplete="off"  [(ngModel)]="lowTo" (input)="lowToChange($event.target)" placeholder="Enter the To" onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57) || (event.target.value.indexOf('.') < 0 && event.target.value.length>0 && event.charCode === 46)">
        </div>
        <div class="col-md-4">
            <button type="button" class="btn btn-primary" style="width: 100px; background-color: rgb(62, 177, 20); border-color: rgb(62, 177, 20);" >LOW</button>
        </div>
    </div>
    <br>
    <div class="row d-flex">
        <div class="col-md-4">
            <input type="text" class="form-control" autocomplete="off" readonly [(ngModel)]="medFrom" placeholder="Enter the From">
        </div>
        <div class="col-md-4">
            <input type="text" class="form-control" autocomplete="off"  [(ngModel)]="medTo" (input)="medToChange($event.target)" placeholder="Enter the To" onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57) || (event.target.value.indexOf('.') < 0 && event.target.value.length>0 && event.charCode === 46)">
        </div>
        <div class="col-md-4">
            <button type="button" class="btn btn-primary" style="width: 100px; background-color: rgb(237, 237, 19); border-color: rgb(237, 237, 19);"  >MEDIUM</button>
        </div>
    </div>
    <br>
    <div class="row d-flex">
        <div class="col-md-4">
            <input type="text" class="form-control" autocomplete="off" readonly  [(ngModel)]="highFrom" placeholder="Enter the From">
        </div>
        <div class="col-md-4">
            <input type="text" class="form-control" autocomplete="off"  [(ngModel)]="highTo" readonly placeholder="Enter the To">
        </div>
        <div class="col-md-4">
            <button type="button" class="btn btn-primary" style="width: 100px;background-color: red; border-color: red;"  >HIGH</button>
        </div>
    </div>
    <hr>
    <div class="row d-flex">
        <div class="form-group col-md-12 text-right">
            <button type="button" class="btn btn-primary" (click)="saveRiskRatingConfig()" >Save</button>
            <button type="button" class="btn btn-secondary" id="rejectButton" (click)="cancelRiskButton()" >Cancel</button>
        </div>
    </div>
</div>
    
</app-modal>

<app-modal #labelConfiguration [modalConfig]="labelConfig">
  <div class="row d-flex" >
    <div class="form-group col-md-3">
      <input type="text" class="form-control" autocomplete="off"  [(ngModel)]="labelName" placeholder="Enter Label">
    </div>
    <div class="form-group col-md-2">
      <button type="button" class="btn btn-primary" (click)="addNewlabel()" >Add Label</button>
    </div>
  </div>
  <hr>
  <br>
  <div class="row d-flex" >
                      
    <div class="form-group col-md-2" *ngFor="let label of labelList;let i=index">
      <div  class="card border-light cards" [attr.style]="labelList[i].style">
        <div class="row">
                <div class="card-header position-relative">
                    <h5 class="text-center">{{labelList[i].label}}</h5>
                    <button type="button" (click)="deleteLabel(i)" *ngIf="labelList[i].deletable" class="close" aria-label="Close">
                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                    </button>
                </div>
        </div>
      </div>
    </div>
    
</div>
  <br>
  <br>
  <div class="row d-flex">
      <div class="form-group col-md-12 text-right">
          <button type="button" class="btn btn-primary" (click)="saveLabel()" >Save</button>
          <button type="button" class="btn btn-secondary" id="rejectButton" (click)="cancelButton()" >Cancel</button>
      </div>
  </div>
    
</app-modal>
